<template>
    <zen-one
        :showuserinfo="false"
        :title="`Cukai Tanah: ${cukai.no_hm ?? 'Loading...'} `"
        :crumbs="crumbs"
    >
        <w-flex class="align-center justify-center" v-if="loading">
            <w-spinner />
        </w-flex>

        <z-page
            title="Kemaskini Ampun Hasil"
            :append-button="true"
            v-if="!loading"
        >
            <w-flex column :gap="3">
                <w-card bg-color="" class="table-hardcode">
                    <hakmilik :cukai="cukai" />
                </w-card>
                <w-card>
                    <w-form @submit.prevent="kemaskini">
                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 20%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >NO MKNK</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>

                                <w-input
                                    v-model="noMknk"
                                    disabled
                                    style="color: blue; width: 100%"
                                >
                                </w-input>
                            </div>
                        </w-flex>
                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 20%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >Nama Pemilik</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>

                                <w-input
                                    v-model="namaPemilik"
                                    disabled
                                    style="color: blue; width: 100%"
                                >
                                </w-input>
                            </div>

                            <div class="xs6">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 25%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >Kategori</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>
                                <w-input
                                    placeholder=""
                                    disabled
                                    v-model="kategori"
                                    style="color: blue"
                                />
                            </div>
                        </w-flex>
                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 20%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >Keluasan</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>
                                <w-input
                                    v-model="keluasan"
                                    disabled
                                    style="color: blue"
                                ></w-input>
                            </div>
                            <div class="xs6">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 25%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >Keluasan Maksimum</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>
                                <w-input
                                    placeholder=""
                                    disabled
                                    v-model="keluasan_mak"
                                    style="color: blue !important"
                                />
                            </div>
                        </w-flex>
                        <w-flex class="mt3">
                            <div class="xs6">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 20%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >Tarikh Mula</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>
                                <w-input
                                    placeholder=""
                                    disabled
                                    v-model="tarikh_mula"
                                    style="color: blue"
                                />
                            </div>

                            <div class="xs6">
                                <w-input
                                    type="date"
                                    v-model="form.tarikh_tamat"
                                    outline
                                    tile
                                    >Tarikh Tamat</w-input
                                >
                            </div>
                        </w-flex>

                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-input
                                    v-model="form.amaun"
                                    type="number"
                                    outline
                                    tile
                                    >Amaun Ampun (RM)</w-input
                                >
                            </div>
                            <div class="xs6">
                                <w-select
                                    v-model="form.status"
                                    :items="status"
                                    outline
                                    tile
                                    :placeholder="[[stat]]"
                                    >Status</w-select
                                >
                            </div>
                        </w-flex>

                        <div class="d-flex justify-end mt3">
                            <w-button class="my1 mr0" type="submit"
                                >Kemaskini</w-button
                            >
                        </div>
                    </w-form>
                </w-card>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import Hakmilik from "../Component/Hakmilik";
import { Inertia } from "@inertiajs/inertia";
import moment from "moment";

export default {
    extends: ZResource,
    props: {
        ampunHasil: [Object],
    },
    components: {
        Hakmilik,
    },
    data() {
        var moment = require("moment");
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Ampun Hasil", route: "/cukai-tanah/ampun-hasil" },
                {
                    label: "Kemaskini Ampun Hasil",
                    route: "/cukai-tanah/senarai",
                },
            ],
            cukai: [],
            cukais: [],
            form: {
                hm_akaun_id:null,
                no_tauliah: null,
                tarikh_tamat: null,
                // amaun_cukai: null,
                amaun: null,
                // peratus_ampun: null,
                // status: null,
                id: null,
            },
            loading: true,
            keluasan: null,
            keluasan_mak: null,
            tarikh_mula: null,
            namaPemilik: null,
            noMknk: null,
            kategori: null,
            status: [
                { value: 1, label: "Aktif" },
                { value: 0, label: "Tidak Aktif" },
            ],
            stat: null,
            tarikh_tamat: null,
        };
    },
    methods: {
        async kemaskini() {
            await axios({
                method: "put",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil/${this.form.id}`,
                responseType: "json",
                data: this.form,
            })
                .then((e) => {
                    if (e.data.length > 0) {
                        console.log(e.data);
                    }
                })
                .finally((e) => {
                    window.location.href = `/cukai-tanah/ampun-hasil`;
                });
            // Inertia.post("/cukai-tanah/kemaskini-ampun-hasil",l);
        },
        async searchCukai() {
            const l = {
                kategoriCarian: "1",
                formOption: "option1",
                barcode: this.ampunHasil.no_hm,
                kodDaerah: "01",
            };
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/cari`,
                responseType: "json",
                data: l,
            })
                .then((e) => {
                    if (e.data.length > 0) {
                        this.cukai = e.data[0];
                        this.form.hm_akaun_id = e.data[0].id;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async getData() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil?limit=1&offset=0&no_hm=${this.ampunHasil.no_hm}`,
                responseType: "json",
            }).then((e) => {
                console.log(e.data.data[0].tarikh_mula);
                this.cukais = e.data.data[0];
                this.noMknk = e.data.data[0].no_tauliah;
                this.form.amaun = e.data.data[0].amaun;
                if(e.data.data[0].tarikh_mula!=null){
                    this.tarikh_mula = moment(e.data.data[0].tarikh_mula).format("YYYY-MM-DD");
                }
                else{
                    this.tarikh_mula='Tiada Tarikh';
                }
                if(e.data.data[0].tarikh_tamat!=null){
                     this.form.tarikh_tamat = moment(e.data.data[0].tarikh_tamat).format("YYYY-MM-DD");
                }
                else{
                    this.tarikh_tamat='Tiada Tarikh';
                }

                this.stat = e.data.data[0].status;
                this.keluasan = e.data.data[0].keluasan;
                this.keluasan_mak = e.data.data[0].keluasan_mak;
                this.form.id = e.data.data[0].id;
                this.form.no_tauliah = e.data.data[0].no_tauliah;
                this.kategori = e.data.data[0].kategori;
                this.namaPemilik = e.data.data[0].pemilik;
            });
        },
    },
    watch: {},
    mounted() {
        this.searchCukai();
        this.getData();
        this.dialog.width = 500;
    },
};
</script>
<style>
::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgb(35, 71, 129);
    font-style: normal;
    opacity: 1; /* Firefox */
}
</style>
